// Français pour les deux verbes fixes de la boîte de confirmation (mêmes valeurs que le vocabulaire partagé).
import { registerFr } from '../i18n/index.js';

registerFr({
  'Cancel': 'Annuler',
  'Confirm': 'Confirmer',
}, 'ConfirmModal');
